import React from 'react';
import {
  Heading,
  Modal,
  ModalBody,
  ModalHeader,
} from '@americanexpress/dls-react';
import { IconLounge } from '@americanexpress/dls-icons';
import { useModal } from '@/context/modalContext';
import { useRouteParams } from '@/context/routeParamsContext';
import {
  useLoungeAmenitiesWithLocaleTranslations,
  useLoungeById,
} from '@/hooks/loungesHooks/loungesHelperHooks';
import { amenityIdToIconMap } from '@/constants/amenityIconMapping';
import { useCommonContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import { isCenturionLounge, resolveImageUrl } from '@/helpers/utils';
import { useSelector } from 'react-redux';
import { getOneCmsLoungeFinderImagesBaseUrl } from '@/selectors/oneCmsSelectors';

const AmenitiesModal = () => {
  const { loungeId } = useRouteParams();
  const { closeModal } = useModal();
  const lounge = useLoungeById(loungeId);
  const amenities = useLoungeAmenitiesWithLocaleTranslations(loungeId);
  const content = useCommonContent();
  const oneCmsImagesBaseUrl = useSelector(getOneCmsLoungeFinderImagesBaseUrl);
  const modalContent = content?.amenities?.exploreAllAmenities;
  const imageSrc = resolveImageUrl(modalContent?.image, oneCmsImagesBaseUrl);

  if (
    !isCenturionLounge(lounge) ||
    !modalContent?.buttonText ||
    amenities.length === 0
  ) {
    return null;
  }

  const modalId = 'amenities-modal';
  const headingId = `${modalId}-heading`;
  const bodyId = `${modalId}-body`;

  return (
    <Modal
      id={modalId}
      aria-labelledby={headingId}
      aria-describedby={bodyId}
      onClose={(event) => closeModal(event, 'close amenities')}
    >
      <ModalHeader
        id={headingId}
        closeButtonProps={{ reactlytics: { disable: true } }}
      >
        <Heading level={2} variant="sans-large-bold">
          {modalContent.buttonText}
        </Heading>
      </ModalHeader>
      <ModalBody id={bodyId}>
        {imageSrc && (
          <img src={imageSrc} alt="" className="margin-2-b width-full" />
        )}
        {modalContent.description && (
          <p className="margin-2-b">{modalContent.description}</p>
        )}
        <ul className="pad-0-lr">
          {amenities.map((amenity) => {
            const AmenityIcon = amenityIdToIconMap[amenity.id] || IconLounge;

            return (
              <li
                key={amenity.id}
                className="flex flex-align-center margin-2-b"
              >
                <span className="margin-1-r">
                  <AmenityIcon color="inherit" size="md" />
                </span>
                <span>{amenity.label}</span>
              </li>
            );
          })}
        </ul>
        {modalContent.footnote && (
          <p className="margin-2-t body-2">{modalContent.footnote}</p>
        )}
      </ModalBody>
    </Modal>
  );
};

export default AmenitiesModal;
